import { DescriptionField } from "@dash/description-list";
import { SectionHeader } from "@dash/page";
import { formatCurrency } from "@legacy-megarax/react-utils";
import { useProfiles } from "@megarax/features";
import _ from "lodash";
import { Link } from "react-router-dom-v5-compat";

import { OrderDto } from "@megaron/crm-contracts";
import { fromDateString } from "@megaron/date-string";
import { getMegaraxPath } from "@megaron/megarax-uri";
import { isNotNull } from "@megaron/utils";
import { Uuid } from "@megaron/uuid";

type Props = {
  order: OrderDto;
};

export const OrderDetails: React.FC<Props> = ({ order }) => {
  const { profile } = useProfiles();

  const createdByProfile = order.createdBy ? profile(order.createdBy) : undefined;
  const invoiceNumberText =
    _(order.lines)
      .map((l) => l.invoiceNumber)
      .filter(isNotNull)
      .uniq()
      .join(", ") || "-";

  return (
    <div css={{ display: "flex", flexDirection: "column", gap: "1rem", width: "100%" }}>
      <SectionHeader isHr>Dane zamówienia</SectionHeader>
      <div css={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: "0.625rem" }}>
        <DescriptionField label="Numer zamówienia">{order.number}</DescriptionField>
        <DescriptionField label="Numer faktury">{invoiceNumberText}</DescriptionField>
        <DescriptionField label="Data zamówienia">{order.orderDate}</DescriptionField>
        {createdByProfile && <DescriptionField label="Złożone przez">{createdByProfile.name}</DescriptionField>}
        <DescriptionField label="Kwota netto">
          {formatCurrency(order.netTotal, order.currency ?? "PLN")}
        </DescriptionField>
        <DescriptionField label="Nabywca">
          <Link
            to={order.sellToId ? getMegaraxPath.uri("megarax://crm/customer/{id}", { id: Uuid(order.sellToId) }) : ""}
          >
            {order.sellToName}
          </Link>
        </DescriptionField>
        <DescriptionField label="Odbiorca faktury">
          <Link
            to={order.billToId ? getMegaraxPath.uri("megarax://crm/customer/{id}", { id: Uuid(order.billToId) }) : ""}
          >
            {order.billToName}
          </Link>
        </DescriptionField>
        <DescriptionField label="Data wysyłki">
          {order.promisedDeliveryDate && fromDateString(order.promisedDeliveryDate).toLocaleDateString()}
        </DescriptionField>
        {/* <DescriptionField label="Marża">
          {formatCurrency(order.profitMargin, order.currency ?? undefined)}
        </DescriptionField> */}
      </div>
    </div>
  );
};
